import CryptoJS from 'crypto-js';
import constantVariable from './constantVariable';
//import trackShipmentSummary from './views/components/trackshipmentsummary/trackshipmentsummary.component.js';

export default {
  showNetworkError(error) {
    try {
      console.log("Error logResult===>" + JSON.stringify(error));
      var errstring = JSON.stringify(error);
      var errobj = JSON.parse(errstring);
      var path = errobj.config.url;
      var directories = path.split("/");
      var methodName = directories[(directories.length - 1)];
      var statuscode = (error && error.response && error.response.status)?error.response.status:500;
      if(statuscode==400){
      var errorMsg = "Invalid input parameter : " + error + " - " + methodName;
      }else{
        var errorMsg;
        if (error.response.data.data == "Invalid login") {
          errorMsg = error.response.data.message;
        } else {
          errorMsg= "Server is down : " + error + " - " + methodName;
        }
      }
      return errorMsg;

    } catch (error) {
      var errorMsg = "Server is down : " + error;
      return errorMsg;
    }
  },

  showNetworkErrorCreateTicket(error) {
    try {
      var errstring = JSON.stringify(error);
      var errobj = JSON.parse(errstring);
      var path = errobj.config.url;
      var directories = path.split("/");
      var methodName = directories[(directories.length - 1)];
      var statuscode = (error && error.response && error.response.status)?error.response.status:500;
      if(statuscode==400){
      var errorMsg = error.response.data.data.msg + " - " + methodName;
      }else{
        var errorMsg;
        if (error.response.data.data == "Invalid login") {
          errorMsg = error.response.data.message;
        } else {
          errorMsg= "Server is down : " + error + " - " + methodName;
        }
      }
      return errorMsg;

    } catch (error) {
      var errorMsg = "Server is down : " + error;
      return errorMsg;
    }
  },

//Mounted functions
getuserDetailsAndpermissionData() {
  // console.log( 'getuserDetailsAndpermissionData' );

  var arrSubDepartmentList = window.localStorage.getItem('userSubDepartment');
  if(arrSubDepartmentList !== []){
    var subDepartmentList = JSON.parse(arrSubDepartmentList);
  }
  else{
    var subDepartmentList=[];
  }

  var arrobjSubDepartmentId = window.localStorage.getItem('userSubDepartmentId');
  if(arrobjSubDepartmentId !== ''){
    var objSubDepartmentId = JSON.parse(arrobjSubDepartmentId);
    var DepartmentID = objSubDepartmentId.value;
  }
  else{
    var DepartmentID = {};
  }

  var userdetailEncrypt = window.localStorage.getItem('userdetail')
  var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), constantVariable.AES_SecretKey);
  var plaintext = bytes.toString(CryptoJS.enc.Utf8);
  var userdetail = JSON.parse(plaintext);
  var userRole = userdetail[0].roles[0].rolename;

  var permissiondataEncrypt = window.localStorage.getItem('permissiondata');

  var bytes = CryptoJS.AES.decrypt(permissiondataEncrypt.toString(), constantVariable.AES_SecretKey);
  var plaintext = bytes.toString(CryptoJS.enc.Utf8);
  var permissiondata = JSON.parse(plaintext);
 
  var DashboardArr = permissiondata.filter(function (val) {
    return val.name == "Dashboard";
  });

  if ('Admin' !== userRole) {

    if (DashboardArr && DashboardArr.length) {
      var component = DashboardArr[0].children.filter(function (val) {
        return val.name == "Inbound";
      });
  
      if (undefined == component) {
        var component = DashboardArr[0].children.filter(function (val) {
          return val.name == "Outbound";
        });
      }  
      var userTypeForTicket = (component.length > 0) ? component[0].name : '';
    } else {
      var userTypeForTicket = '';
    }
       
  }
  let childrenArr = (DashboardArr && DashboardArr[0] && DashboardArr[0].children)?DashboardArr[0].children:[];
  let businessFlowOptionObj = [];
  let businessFlowSelectOptionObj = {
    value: '',
    text: ''
  };
  var forwardObj = '';
  if (childrenArr.length > 0) {
    for (var i = 0; i < childrenArr.length; i++) {

      if (childrenArr[i].url === '/reverseticketsummary') {

          businessFlowSelectOptionObj = {
              value: '2',
              text: 'Reverse'
          };
          businessFlowOptionObj.push( businessFlowSelectOptionObj );
      }
      if (childrenArr[i].url === '/forwardticketsummary') {
          forwardObj = "1";
          businessFlowSelectOptionObj= {
              value: '1',
              text: 'Forward'
          };
          businessFlowOptionObj.push( businessFlowSelectOptionObj );
      }
  }  
  }
  
  if (forwardObj === "1") {
      businessFlowSelectOptionObj = {
          value: '1',
          text: 'Forward'
      };
  }
  return [subDepartmentList, DepartmentID, userdetail, permissiondata, userTypeForTicket, businessFlowSelectOptionObj, businessFlowOptionObj];
},
  //Mounted functions
  getuserDetailsAndpermissionData_bk() {
    // console.log( 'getuserDetailsAndpermissionData' );

    var arrSubDepartmentList = window.localStorage.getItem('userSubDepartment');
    if(arrSubDepartmentList !== []){
      var subDepartmentList = JSON.parse(arrSubDepartmentList);
    }
    else{
      var subDepartmentList=[];
    }

    var arrobjSubDepartmentId = window.localStorage.getItem('userSubDepartmentId');
    if(arrobjSubDepartmentId !== ''){
      var objSubDepartmentId = JSON.parse(arrobjSubDepartmentId);
      var DepartmentID = objSubDepartmentId.value;
    }
    else{
      var DepartmentID = {};
    }

    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    var userRole = userdetail[0].roles[0].rolename;

    var permissiondataEncrypt = window.localStorage.getItem('permissiondata');

    var bytes = CryptoJS.AES.decrypt(permissiondataEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var permissiondata = JSON.parse(plaintext);
    var DashboardArr = permissiondata.filter(function (val) {
      return val.name == "Dashboard";
    });

    if ('Admin' !== userRole) {
      var component = DashboardArr[0].children.filter(function (val) {
        return val.name == "Inbound";
      });
      if (undefined == component) {
        var component = DashboardArr[0].children.filter(function (val) {
          return val.name == "Outbound";
        });
      }
      var userTypeForTicket = (component.length > 0) ? component[0].name : '';
    }
    let childrenArr = DashboardArr[0].children;
    let businessFlowOptionObj = [];
    let businessFlowSelectOptionObj = {
      value: '',
      text: ''
    };
    var forwardObj = '';
    for (var i = 0; i < childrenArr.length; i++) {

        if (childrenArr[i].url === '/reverseticketsummary') {

            businessFlowSelectOptionObj = {
                value: '2',
                text: 'Reverse'
            };
            businessFlowOptionObj.push( businessFlowSelectOptionObj );
        }
        if (childrenArr[i].url === '/forwardticketsummary') {
            forwardObj = "1";
            businessFlowSelectOptionObj= {
                value: '1',
                text: 'Forward'
            };
            businessFlowOptionObj.push( businessFlowSelectOptionObj );
        }
    }
    if (forwardObj === "1") {
        businessFlowSelectOptionObj = {
            value: '1',
            text: 'Forward'
        };
    }
    return [subDepartmentList, DepartmentID, userdetail, permissiondata, userTypeForTicket, businessFlowSelectOptionObj, businessFlowOptionObj];
  },
  reformatDateString(s) {
    var b = s.split(/\D/);
    b[0] = ('0' + b[0]).slice(-2);
    b[1] = ('0' + b[1]).slice(-2);
    return b.reverse().join('-');
  },

  formatDateString(s) {
    var b = s.split(" ");
    var k = b[0].split("-");
    return k.reverse().join('-');
  },
  changeDateFormat(s) {
    var b = s.split(" ");
    var k = b[0].split("-");
    return k.join('-');
  },
  // === B2B CRM ALT Instruction Section Start === --Format date in DD-MM-YYYY HH-MM-SS
   formatDateToCustom(dateString) {
      if (!dateString) return null;

      const inputDate = new Date(dateString);

      const formattedDate = inputDate.toLocaleString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      }).replace(",", "");

      return formattedDate.replace(/\//g, "-");
    },
    // === B2B CRM ALT Instruction Section End ===
  closeBModalCommonFunction(string) {
    switch (string) {
      case 'Ticketmodal':
        var filter = '';
        var Ticketmodal = false;
        break;
      case 'SendSMSModal':
        var filter = '';
        var SendSMSModal = false;
        break;
      case 'locationMapModal':
        var filter = '';
        var locationMapModal = false;
        break;
      case 'BagShipmentDetailsModal':
        var filter = '';
        var BagShipmentDetailsModal = false;
        break;
      case 'TransitStatusModal':
        var filter = '';
        var TransitStatusModal = false;
        break;
      case 'ShipmentLogModal':
        var filter = '';
        var ShipmentLogModal = false;
        break;
      case 'CallPatchingModal':
        var filter = '';
        var CallPatchingModal = false;
        break;
      case 'ticketResultModal':
        var filter = '';
        var ticketResultModal = false;
        break;
      case 'MultipleProductInfo.MultipleProductInfoModal':
        var filter = '';
        var MultipleProductInfoModal = false;
        break;
      case 'TicketLogModal':
          var filter = '';
          var TicketLogModal = false;
          break;
        case 'IVRCallRecording.IVRCallRecordingModal':
          var filter = '';
          var IVRCallRecordingModal = false;
          break;
      case 'UploadRTODocsmodal':
        var filter = '';
        var UploadRTODocsmodal = false;
        break;
      default:
        string = '';
    }
    return [filter, Ticketmodal, SendSMSModal, locationMapModal, BagShipmentDetailsModal, TransitStatusModal, ShipmentLogModal, CallPatchingModal, ticketResultModal, MultipleProductInfoModal,TicketLogModal,IVRCallRecordingModal,UploadRTODocsmodal, string];
  },
  checkcommentvalidation(string){
    if (!/^[\w'"()\s]*$/.test(string)) {
      return false;
    }else{
      return true
    }
  },

  getInvalidShippingIDs(shippingIDsString) {
    const invalidShippingIDs = shippingIDsString
      .split(',')
      .map((id) => id.trim())
      .filter((id) => !/^[12356]/.test(id.charAt(0)) || id.length < 8 || id.length > 20);   //#awb_format To handle new awb format change 

    return invalidShippingIDs.join(',');
  },
  // === Shipment Validation -- Shipment shouild be greater than 8 && less then 20 && not alpha numeric 
  validateShippingID(shippingID) {
    const id = (shippingID || "").trim();
  
      // Allow A-Z, a-z, 0-9 → length 8–20
  return /^[A-Za-z0-9]{8,20}$/.test(id);
  },
  // === Shipment Validation -- Shipment shouild be greater than 8 && less then 20 && not alpha numeric 
  getusertoken(){
    let userToken = window.localStorage.getItem('userToken');
    let authHeaders = {
      'Authorization': `Bearer ${userToken}`,
      'versionnumber': 'v2',
      'CSRF-Token': constantVariable.CSRF_TOKEN
    };
    return authHeaders
  }
}



// WEBPACK FOOTER //
// ./src/commonFunction.js